import { memo } from 'react';
import React from 'react';
import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { EntityWithTicketsQuery } from 'src/WebApiController';

import { useTrackComponent } from '../AppPerformanceContext';
import { CatalogMetricsContextProviderProps } from './CatalogMetrics.type';
import { CatalogMetricsContextV2Provider } from './CatalogMetricsContextV2';

function CatalogMetricsContextProviderRaw<
  TMetrics extends { currency: string | null },
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(props: CatalogMetricsContextProviderProps<TMetrics, TQuery>) {
  // If we need to test new Metrics vNext, we would add them here
  // For example:
  // return <CatalogMetricsContextV3Provider {...props} />;
  useTrackComponent('CatalogMetricsContextProviderRaw');

  // Consignors use the same V2 provider as regular users. The backend
  // endpoints (GetCatalogMetricsForListings, GetCatalogDetailedMetricsForListings)
  // already aggregate metrics across all consignees via ConsigneeAggregatorHelper.
  return <CatalogMetricsContextV2Provider {...props} />;
}

export const CatalogMetricsContextProvider = memo(
  CatalogMetricsContextProviderRaw
) as <
  TMetrics extends { currency: string | null },
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(
  props: CatalogMetricsContextProviderProps<TMetrics, TQuery>
) => React.JSX.Element;
